import { defineComponent as _defineComponent } from 'vue'
import profileNavItems from '@sh/components/Layout/Header/HeaderV2/profileNavItems';
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';
import session from '@sh/services/session';
import { User } from '@sh/types';
import { computed, ref } from 'vue';

interface Props {
  user: User;
}

interface Emits {
  (e: 'logout'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar.ts',
  props: {
    user: null
  },
  emits: ["logout"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'logout'): void;
}), expose: any, slots: any, attrs: any }) {

const { user } = __props as {
  user: User;
};





const popoverRef = ref<HTMLElement | null>(null);

const username = computed(() => {
  const fullName = `${user.firstname} ${user.lastname}`;
  return user.firstname && user.lastname ? fullName : user.username || 'User';
});

const initials = computed(() => {
  const [firstName, lastName] = username.value.trim().split(' ');
  return firstName && lastName ? `${firstName[0]}${lastName[0]}` : username.value.substring(0, 2);
});

function logOut() {
  emits('logout');
}

function popoverShown() {
  setTimeout(() => popoverRef.value?.focus(), 0);
}

return { __sfc: true,emits, popoverRef, username, initials, logOut, popoverShown, profileNavItems, OptimizerIconV2, session }
}

})